import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import { INITIAL_STATE } from './constants/filterDialog.general';
import { FILTER_PROPTYPE, SELECTED_FILTER_GROUP_PROPTYPE } from '../constants/filterSection.propTypes';

// Containers
import withActions from '../../../connectors/withActions';

// Helpers
import ACTION_HANDLERS from './helpers/filterDialog.actionHandlers';

// Components
import FilterDialogSection from './molecules/filterDialogSection';

// Mock Data
import FILTER_TYPES_MOCKS from '../mocks/sampleFilterTypes';
import { DEFAULT_FILTER_GROUP } from '../constants/filterSection.filterGroups';
var FilterDialog = withActions(INITIAL_STATE, ACTION_HANDLERS)(FilterDialogSection);
FilterDialog.propTypes = {
  onFilterApply: PropTypes.func,
  filterTypes: PropTypes.arrayOf(FILTER_PROPTYPE),
  selectedFilters: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    operator: PropTypes.string,
    values: PropTypes.any
  })),
  moduleType: PropTypes.string,
  appliedFilterGroup: SELECTED_FILTER_GROUP_PROPTYPE,
  defaultFilterTypes: PropTypes.arrayOf(PropTypes.string),
  filterGroups: PropTypes.array,
  selectedFilterGroup: PropTypes.string
};
FilterDialog.defaultProps = {
  onFilterApply: _noop,
  filterTypes: FILTER_TYPES_MOCKS,
  selectedFilters: EMPTY_ARRAY,
  moduleType: '',
  appliedFilterGroup: undefined,
  defaultFilterTypes: EMPTY_ARRAY,
  filterGroups: EMPTY_ARRAY,
  selectedFilterGroup: DEFAULT_FILTER_GROUP
};
export default FilterDialog;